import HomePage from './home'
import HistoriaPage, { DadosPage, RegulamentoPage, MidiaPage, RecordAudioPage, PlayAudioPage, RecordVideoPage, PlayVideoPage, ArquivoPage, EscrevaPage, ConcluirPage } from './historia'

export default HomePage

export {
    DadosPage, RegulamentoPage, HistoriaPage, MidiaPage, RecordAudioPage, PlayAudioPage, RecordVideoPage, PlayVideoPage, ArquivoPage, EscrevaPage, ConcluirPage
}
